import React, {Component} from 'react';
import {Button, Modal, Form, Header, Grid, Table, Label, Popup, Checkbox} from 'semantic-ui-react';
import {FormattedNumber} from 'react-intl';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import SaleData from "../../data/SaleData";
import CustomDivider from "../extras/CustomDivider";
import {connect} from "react-redux";
import {totalSale} from "../../actions/SaleTotalAction";
import {paymentDialog} from "../../actions/PaymentDialogActions";
import DiscountForm from "../sale/DiscountForm";
import c from "../../constants";
import {showToast} from "../../actions/ToastAction";
import NoData from "../extras/NoData";
import TicketData from "../../data/TicketData";
import {selectTicket} from "../../actions/TicketSelectActions";
import { openPrinterSettingsModal } from "../../actions/PrinterSettingsModalAction";
import {ticketClientDialogActions} from "../../actions/TicketClientDialogActions";
import PrinterData from "../../data/PrinterData";
import DeliveryForm from "../sale/DeliveryForm";
import TipForm from "../sale/TipForm";
import {listProductsSale} from "../../actions/ProductsSaleActions";
import SaleItemData from "../../data/SaleItemData";

const moneyMask = createNumberMask({
    prefix: '$',
});

const styles = {
    totalTitle: {
        color: 'black',
        fontSize: 'small'
    },
    headerTotal: {
        marginTop: '0px'
    }
};

class PaymentDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amt_tendered: '',
            type: 1,
            sale: null,
            total_sale: this.props.total_sale,
            change: 0,
            amt_tendered_error: false,
            btn_sending: false,
            open_modal_printer: false,
            print_order: false,
            extra_print_data: {
                amt_tendered: 0,
                change: 0,
                payment_type: 1
            }
        };

        this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
        this.handleAmtTenderedChange = this.handleAmtTenderedChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCloseModalPrinter = this.handleCloseModalPrinter.bind(this);
        this.printInvoice = this.printInvoice.bind(this);
        this.printOrder = this.printOrder.bind(this);
        this.getPayment = this.getPayment.bind(this);
        this.togglePrintCommand = this.togglePrintCommand.bind(this);
    }

    handlePaymentTypeChange = (result) => {
        this.setState({type: result});
    };

    componentWillReceiveProps(nextProps){
        if(nextProps.total_sale){
            this.setState({amt_tendered:'', change:0});
        }
    }

    handleAmtTenderedChange = (event) => {
        let amt_tendered = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let change = (this.props.total_sale.payments + amt_tendered) - (this.props.total_sale.total_sale - (this.props.total_sale.discount + this.props.total_sale.items_discount));
        this.setState({
            amt_tendered,
            amt_tendered_error: false,
            change: isNaN(change) ? 0:change
        });
        this.getPayment();
    };

    getPayment() {
        let balance = (this.props.total_sale.total_sale - (this.props.total_sale.discount + this.props.total_sale.items_discount)) - this.props.total_sale.payments;
        if (this.state.amt_tendered > balance) {
            return balance;
        } else {
            return this.state.amt_tendered;
        }
    };

    async list_sale_items(){
        let products_sale = await SaleItemData.getList(this.props.sale.id);
        this.props.listProductsSale(products_sale);
    }

    handleSubmit() {
        if (!this.state.btn_sending && this.getPayment()) {
            this.setState({btn_sending: true});
            if(this.props.type === 'sale'){
                let data = {
                    order: {
                        sale: this.props.sale.id,
                    },
                    payment: {
                        type: this.state.type,
                        payment: this.getPayment()
                    }
                };
                SaleData.end(data, (res) => {
                    if (res && res.update) {
                        this.setState({extra_print_data: {amt_tendered: this.state.amt_tendered, change: this.state.change, payment_type: this.state.type}});
                        this.props.showToast({message: 'Pago Realizado!', type: 'success'});
                        this.props.totalSale(res.data);
                        this.props.paymentDialog(false);
                        this.list_sale_items();
                        this.setState({btn_sending: false, amt_tendered:0, open: false, open_modal_printer: true});
                    } else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo de nuevo!', type: 'error'});
                    }
                    this.setState({btn_sending: false});
                });
            }else if(this.props.type === 'ticket'){
                let data = {
                    client: this.props.select_client.id,
                    ticket: this.props.payment_dialog.ticket,
                    sale_type: this.state.type,
                    discount: this.props.total_sale.discount,
                    payment: this.getPayment()
                };
                TicketData.sale(data, res =>{
                    if(res.save){
                        this.props.selectTicket(res.data);
                        this.props.showToast({message: 'Pago Realizado!', type: 'success'});
                        this.props.ticketClientDialog({open:false, ticket:null});
                        this.props.paymentDialog(false);
                    }else{
                        this.props.showToast({message: 'Por favor haga una apertura de caja!', type: 'error'});
                    }
                    this.setState({btn_sending: false, amt_tendered:0, open: false});
                })
            }
        } else {
            this.setState({amt_tendered_error: true})
        }
    };

    handleClose = () => {
        this.props.paymentDialog(false);
    };

    togglePrintCommand = () => this.setState((prevState) => ({ print_order: !prevState.print_order }))

    handleCloseModalPrinter = () => {
        this.setState({open_modal_printer: false})
    };

    printInvoice(items){
        this.setState({ sending_ticket: true, open_modal_printer:false });
        PrinterData.printInvoice(this.props.sale.id, this.state.extra_print_data, items).then((res) => {
            this.props.showToast({ message: res, type: 'success' });
            this.setState({ sending_ticket: false });
        }, err => {
            if (err === 1) {
                this.props.openPrinterSettingsModal({ is_open: true });
            } else if (err === 2) {
                this.props.showToast({ message: 'Tenemos un problema en el servidor', type: 'error' });
            }
            this.setState({ sending_ticket: false });
        })
        if(this.state.print_order){
            this.printOrder()
        }
    }

    printOrder(){
        PrinterData.printOrder(this.props.sale.id, null).then((res) =>{
            this.props.showToast({message:res, type:'success'});
            this.setState({sending_order: false});
        }, err =>{
            if(err === 1){
                this.props.openPrinterSettingsModal({is_open:true});
            }else if(err === 2){
                this.props.showToast({message:'Tenemos un problema en el servidor', type:'error'});
            }
            this.setState({sending_order: false});
        })
    }

    render() {
        return (
            <div>
                <Modal size='large' dimmer='inverted' open={this.props.payment_dialog} onClose={this.handleClose}>
                    <Modal.Header>Forma de Pago</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Grid.Row>
                                                <Table celled>
                                                    <Table.Header>
                                                        <Table.Row textAlign='center'>
                                                            <Table.HeaderCell>TOTAL VENTA</Table.HeaderCell>
                                                            <Table.HeaderCell>DESCUENTO</Table.HeaderCell>
                                                            <Table.HeaderCell>IMPUESTOS</Table.HeaderCell>
                                                            <Table.HeaderCell>DOMICILIO</Table.HeaderCell>
                                                            <Table.HeaderCell>PROPINA</Table.HeaderCell>
                                                            <Table.HeaderCell>ABONOS</Table.HeaderCell>
                                                            <Table.HeaderCell>VALOR A PAGAR</Table.HeaderCell>
                                                            <Table.HeaderCell
                                                                color={this.state.change < 0 ? 'orange' : 'green'}>{this.state.change < 0 ? 'SALDO' : 'CAMBIO'}</Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        <Table.Row textAlign='center'>
                                                            <Table.Cell>
                                                                <Header as='h2' color='orange'
                                                                        style={styles.headerTotal}>
                                                                    $<FormattedNumber
                                                                    value={this.props.total_sale.total_sale ? this.props.total_sale.total_sale:0}
                                                                    currency="USD"
                                                                    maximumFractionDigits={0}
                                                                    minimumFractionDigits={0}/>
                                                                </Header>
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Popup
                                                                    trigger={
                                                                        <Label as='a'>
                                                                            $<FormattedNumber value={this.props.total_sale.discount} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/> ó&nbsp;
                                                                            {(this.props.total_sale.discount/this.props.total_sale.total_sale*100)}%
                                                                        </Label>
                                                                    }
                                                                    content={<DiscountForm sale={this.props.sale}/>}
                                                                    on='click'
                                                                    onClose={()=>this.setState({amt_tendered:''})}
                                                                    position='top right'
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Popup trigger={<Label as='a'>$<FormattedNumber
                                                                    value={this.props.total_sale.taxes ? this.props.total_sale.taxes.reduce((a, b) => { return a + b.vlr_base; }, 0):0}
                                                                    currency="USD"
                                                                    maximumFractionDigits={0}
                                                                    minimumFractionDigits={0}/>
                                                                </Label>} flowing hoverable>
                                                                    <Table celled>
                                                                        <Table.Header>
                                                                            <Table.Row textAlign='center'>
                                                                                <Table.HeaderCell colSpan={3}>INFORMACIÓN TRIBUTARIA</Table.HeaderCell>
                                                                            </Table.Row>
                                                                            <Table.Row textAlign='center'>
                                                                                <Table.HeaderCell>%</Table.HeaderCell>
                                                                                <Table.HeaderCell>VALOR BASE</Table.HeaderCell>
                                                                                <Table.HeaderCell>VALOR IMPUESTO</Table.HeaderCell>
                                                                            </Table.Row>
                                                                        </Table.Header>
                                                                        <Table.Body>
                                                                            {this.props.total_sale.taxes.length > 0 ? this.props.total_sale.taxes.map(tax => {
                                                                                return(
                                                                                    <Table.Row textAlign='center' key={tax.percentage}>
                                                                                        <Table.Cell>
                                                                                            {tax.percentage}%
                                                                                        </Table.Cell>
                                                                                        <Table.Cell>
                                                                                            $<FormattedNumber
                                                                                            value={tax.tax}
                                                                                            currency="USD"
                                                                                            maximumFractionDigits={1}
                                                                                            minimumFractionDigits={0}/>
                                                                                        </Table.Cell>
                                                                                        <Table.Cell>
                                                                                            $<FormattedNumber
                                                                                            value={tax.vlr_base}
                                                                                            currency="USD"
                                                                                            maximumFractionDigits={1}
                                                                                            minimumFractionDigits={0}/>
                                                                                        </Table.Cell>
                                                                                    </Table.Row>
                                                                                )
                                                                            }):<NoData colSpan={3}/>}
                                                                        </Table.Body>
                                                                    </Table>
                                                                </Popup>
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Popup
                                                                    trigger={
                                                                        <Label as='a'>
                                                                            $<FormattedNumber value={this.props.total_sale.delivery_price} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                                                                        </Label>
                                                                    }
                                                                    content={<DeliveryForm sale={this.props.sale}/>}
                                                                    on='click'
                                                                    onClose={()=>this.setState({amt_tendered:''})}
                                                                    position='top right'
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Popup
                                                                    trigger={
                                                                        <Label as='a'>
                                                                            $<FormattedNumber value={this.props.total_sale.tip} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                                                                        </Label>
                                                                    }
                                                                    content={<TipForm tip={this.props.total_sale.tip} sale_id={this.props.sale.id}/>}
                                                                    on='click'
                                                                    onClose={()=>this.setState({amt_tendered:''})}
                                                                    position='top right'
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Header as='h2' color='orange'
                                                                        style={styles.headerTotal}>
                                                                    $<FormattedNumber
                                                                    value={this.props.total_sale.payments ? this.props.total_sale.payments:0}
                                                                    currency="USD"
                                                                    maximumFractionDigits={0}
                                                                    minimumFractionDigits={0}/>
                                                                </Header>
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Header as='h2' color='orange'
                                                                        style={styles.headerTotal}>
                                                                    $<FormattedNumber
                                                                    value={this.props.total_sale.balance ? this.props.total_sale.balance:0}
                                                                    currency="USD"
                                                                    maximumFractionDigits={0}
                                                                    minimumFractionDigits={0}/>
                                                                </Header>
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Header as='h2'
                                                                        color={this.state.change < 0 ? 'orange' : 'green'}
                                                                        style={styles.headerTotal}>
                                                                    $<FormattedNumber
                                                                    value={Math.abs(this.state.change)} currency="USD"
                                                                    maximumFractionDigits={0}
                                                                    minimumFractionDigits={0}/>
                                                                </Header>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    </Table.Body>
                                                </Table>
                                                <CustomDivider/>
                                            </Grid.Row>
                                            <Grid columns={2}>
                                                <Grid.Column>
                                                    <Form.Select placeholder='Forma de Pago' label='Forma de Pago'
                                                                options={c.PAYMENT_TYPES} value={this.state.type}
                                                                onChange={(e, {value}) => this.handlePaymentTypeChange(value)}/>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <Form.Input label='Valor Recibido'
                                                                value={this.state.amt_tendered}
                                                                error={this.state.amt_tendered_error}
                                                                children={
                                                                    <MaskedInput
                                                                        autoFocus
                                                                        mask={moneyMask}
                                                                        placeholder='Valor Recibido'
                                                                        onChange={this.handleAmtTenderedChange}
                                                                    />
                                                                }
                                                    />
                                                </Grid.Column>
                                            </Grid>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        {this.props.total_sale.balance > 0 ?<Button primary icon='money' labelPosition='left'
                                                                    onClick={this.state.btn_sending ? null:this.handleSubmit} loading={this.state.btn_sending}
                                                                    disabled={this.state.btn_sending} content="Pagar"/>:null}
                    </Modal.Actions>
                </Modal>

                <Modal size='tiny' dimmer='inverted' open={this.state.open_modal_printer} onClose={() => this.handleCloseModalPrinter()}>
                    <Modal.Header>Imprimir Factura</Modal.Header>
                    <Modal.Content>
                        <p>¿Quieres imprimir la factura?</p>
                        <Checkbox
                            label='Imprimir toda la comanda'
                            name='print_order'
                            value={this.state.print_order}
                            onChange={this.togglePrintCommand}
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.handleCloseModalPrinter()}>
                            No
                        </Button>
                        <Button onClick={() => this.printInvoice('last')}>
                            Imprimir último pago
                        </Button>
                        <Button primary onClick={() => this.printInvoice('all')}>
                            Imprimir toda la factura
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        payment_dialog: state.get('payment_dialog'),
        select_client: state.get('select_client'),
        total_sale: state.get('total_sale'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        totalSale(total) {
            dispatch(totalSale(total))
        },
        paymentDialog(product) {
            dispatch(paymentDialog(product));
        },
        showToast(data) {
            dispatch(showToast(data));
        },
        selectTicket(data){
            dispatch(selectTicket(data))
        },
        ticketClientDialog(data){
            dispatch(ticketClientDialogActions(data))
        },
        openPrinterSettingsModal(modal) {
            dispatch(openPrinterSettingsModal(modal))
        },
        listProductsSale(products_sale) {
            dispatch(listProductsSale(products_sale));
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentDialog);



// WEBPACK FOOTER //
// ./src/components/my_bisttro/PaymentDialog.js